import React from 'react';
import { Button, Form, Input, Switch } from 'antd';
import { openNotification } from '../../../utils';
import { createGroup, updateGroup, getGroup } from '../services/groupService';
import { CreateGroupDto } from '../types/Group';

export default function GroupForm({ id, onSuccess }: { id?: number; onSuccess: () => void }) {
  const [form] = Form.useForm<CreateGroupDto>();

  React.useEffect(() => {
    if (id) {
      getGroup(id).then(d => { const data: any = { ...d }; form.setFieldsValue(data); });
    } else {
      form.resetFields();
      form.setFieldsValue({ isActive: true });
    }
  }, [id, form]);

  const onFinish = async (values: CreateGroupDto) => {
    const data: any = { ...values };
    try {
      if (id) {
        await updateGroup(id, data);
        openNotification('success', 'Başarılı', 'Kategori Güncellendi');
      } else {
        await createGroup(data);
        openNotification('success', 'Başarılı', 'Kategori Eklendi');
      }
      onSuccess();
    } catch (e) {
      openNotification('error', 'Hata', 'Kategori işlemi başarısız');
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout='vertical'>
      <Form.Item name='name' label='Kategori Adı' rules={[{ required: true }]}>
        <Input style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name='isActive' label='Aktif' valuePropName='checked'>
        <Switch />
      </Form.Item>
      <Button htmlType='submit' type='primary' block>Kaydet</Button>
    </Form>
  );
}
